import { EventStatus } from '@app/graphql';

export const hasEventEnded = ({
  expired,
  status,
  timeEnd,
}: {
  expired: boolean;
  status: string;
  timeEnd: string;
}) => {
  return (
    !expired && status === EventStatus.Live && new Date(timeEnd) <= new Date()
  );
};
